import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/authService';
import { getErrorMessage } from '../utils/errors';
import {
  Container,
  Paper,
  TextField,
  Button,
  Box,
  Alert,
  Typography,
} from '@mui/material';

const RecuperarSenha: React.FC = () => {
  const [email, setEmail] = useState('');
  const [erro, setErro] = useState('');
  const [sucesso, setSucesso] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErro('');
    setSucesso('');
    setLoading(true);

    try {
      const mensagem = await authService.forgotPassword(email);
      setSucesso(mensagem);
    } catch (error) {
      setErro(getErrorMessage(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container disableGutters maxWidth="sm">
      <Box sx={{ mt: 10 }}>
        <Paper elevation={3} sx={{ p: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <img src="/images/logomarca.png" alt="GFrotas" style={{ height: 100 }} />
          </Box>

          <Typography variant="h5" align="center" gutterBottom>
            Recuperar senha
          </Typography>
          <Typography variant="body2" align="center" sx={{ mb: 2 }}>
            Informe seu email e enviaremos um link para redefinir sua senha.
          </Typography>

          {erro && <Alert severity="error" sx={{ mb: 2 }}>{erro}</Alert>}
          {sucesso && <Alert severity="success" sx={{ mb: 2 }}>{sucesso}</Alert>}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              margin="normal"
              required
              disabled={loading}
              InputLabelProps={{ shrink: true }}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              size="large"
              disabled={loading || sucesso !== ''}
              sx={{ mt: 3 }}
            >
              {loading ? 'Enviando...' : 'Enviar link de recuperação'}
            </Button>
          </form>

          <Box sx={{ mt: 2, textAlign: 'center' }}>
            <Button onClick={() => navigate('/login')}>Voltar para o login</Button>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default RecuperarSenha;
